import React,
{
    useEffect,
    useState
}
from 'react';
import
{
    navigate
}
from './Router';
import './Projects.css';

const PROJECTS_DATA_URL = '/projects.json';

const FALLBACK_DATA = {
    hero:
    {
        eyebrow: '',
        title: 'Projects',
        subtitle: 'a collection of projects ive done or worked for with some ppl',
    },
    categories: [
    {
        id: 'personal',
        label: 'Personal Projects',
        description: 'Site work, tools, experiments, and anything else you have personally made or contributed to.',
    },
    {
        id: 'games',
        label: 'Game Projects',
        description: 'Games, mods, and interactive builds you made or helped make.',
    }, ],
    projects: [
    {
        id: 'aw24-site',
        title: 'AW24 Website',
        category: 'personal',
        summary: 'The main site shell with animated routing, audio systems, and custom subpages.',
        role: 'Owner, designer, and maintainer of the interactive site experience.',
        status: 'Active',
        links: [
        {
            label: 'Main Page',
            href: '/main'
        }, ],
    },
    {
        id: 'collab-slot',
        title: 'Collaboration Slot',
        category: 'personal',
        summary: 'Placeholder for a project you contributed to but did not fully own.',
        role: 'Replace with actual scope, responsibilities, and results.',
        status: 'Draft',
        links: [],
    },
    {
        id: 'game-slot',
        title: 'Game Project Slot',
        category: 'games',
        summary: 'Placeholder for games, mods, jam entries, or gameplay systems.',
        role: 'Replace with the exact contribution once the real list is ready.',
        status: 'Draft',
        links: [],
    }, ],
};

function normalizeProjectsData(rawData)
{
    const safeData = rawData && typeof rawData === 'object' ? rawData :
    {};
    const categories = Array.isArray(safeData.categories) && safeData.categories.length ?
        safeData.categories.filter(Boolean) :
        FALLBACK_DATA.categories;
    const projects = Array.isArray(safeData.projects) && safeData.projects.length ?
        safeData.projects.filter(Boolean) :
        FALLBACK_DATA.projects;

    return {
        hero:
        {
            ...FALLBACK_DATA.hero,
            ...(safeData.hero && typeof safeData.hero === 'object' ? safeData.hero :
            {}),
        },
        categories,
        projects,
    };
}

export default function Projects()
{
    const [pageData, setPageData] = useState(FALLBACK_DATA);
    const [selectedCategory, setSelectedCategory] = useState('all');

    useEffect(() =>
    {
        let ignore = false;

        const loadProjects = async () =>
        {
            try
            {
                const response = await fetch(PROJECTS_DATA_URL,
                {
                    cache: 'no-store'
                });
                if (!response.ok) return;

                const data = await response.json();
                if (!ignore)
                {
                    setPageData(normalizeProjectsData(data));
                }
            }
            catch (e)
            {}
        };

        loadProjects();
        return () =>
        {
            ignore = true;
        };
    }, []);

    useEffect(() =>
    {
        if (selectedCategory === 'all') return;

        const exists = pageData.categories.some((category) => category && category.id === selectedCategory);
        if (!exists)
        {
            setSelectedCategory('all');
        }
    }, [pageData.categories, selectedCategory]);

    const visibleProjects = pageData.projects.filter((project) =>
    {
        if (!project || typeof project !== 'object') return false;
        return selectedCategory === 'all' || project.category === selectedCategory;
    });

    return ( <div className = "projects-page" >
            <div className = "projects-page__backdrop" />

            <div className = "projects-page__shell" >
            <section className = "projects-panel projects-panel--top" >
            <div className = "projects-panel__hero" >
            {
                pageData.hero.eyebrow ? <div className = "projects-hero__eyebrow" >
                {
                    pageData.hero.eyebrow
                } </div> : null} <h1 className = "projects-hero__title" >
                {
                    pageData.hero.title
                } </h1> <p className = "projects-hero__subtitle" >
                {
                    pageData.hero.subtitle
                } </p> </div>

                <div className = "projects-tabs"
                role = "tablist"
                aria-label = "Project categories" >
                <button
                type = "button"
                className = {
                    selectedCategory === 'all' ? 'projects-tab projects-tab--active' : 'projects-tab'
                }
                onClick = {
                    () => setSelectedCategory('all')
                } >
                All Projects </button>
                {
                    pageData.categories.map((category) => ( <button key = {
                            category.id
                        }
                        type = "button"
                        className = {
                            selectedCategory === category.id ? 'projects-tab projects-tab--active' : 'projects-tab'
                        }
                        onClick = {
                            () => setSelectedCategory(category.id)
                        } >
                        {
                            category.label
                        } </button>
                    ))
                } </div> </section>

                <section className = "projects-results"
                aria-live = "polite" >
                <div className = "projects-results__header" >
                <div >
                <div className = "projects-panel__label" > Visible Projects </div> <p className = "projects-panel__hint" >
                {
                    visibleProjects.length
                }
                card
                {
                    visibleProjects.length === 1 ? '' : 's'
                }
                in this category. </p> </div> </div>

                <div className = "projects-grid" >
                {
                    visibleProjects.map((project) => ( <article key = {
                                project.id || project.title
                            }
                            className = "project-card" >
                            <div className = "project-card__header" >
                            <div >
                            <div className = "project-card__category" >
                            {
                                (pageData.categories.find((category) => category.id === project.category) ||
                                {}).label || 'Uncategorized'
                            } </div> <h2 className = "project-card__title" >
                            {
                                project.title || 'Untitled Project'
                            } </h2> </div>
                            {
                                project.status ? <span className = "project-card__status" >
                                    {
                                        project.status
                                    } </span> : null} </div>

                                    <p className = "project-card__summary" >
                                    {
                                        project.summary || 'Add a summary in projects.json.'
                                    } </p>

                                {
                                    project.role ? ( <p className = "project-card__role" >
                                        <span > Contribution: </span> {project.role} </p>
                                    ) : null
                                }

                                {
                                    Array.isArray(project.links) && project.links.length ? ( <div className = "project-card__links" >
                                        {
                                            project.links.map((link) =>
                                            {
                                                const href = link && link.href ? link.href : '';
                                                const label = link && link.label ? link.label : 'Open';
                                                if (!href) return null;

                                                if (href.startsWith('/'))
                                                {
                                                    return ( <button key = {
                                                            `${project.id}-${label}-${href}`
                                                        }
                                                        type = "button"
                                                        className = "project-card__link project-card__link--button"
                                                        onClick = {
                                                            () => navigate(href)
                                                        } >
                                                        {
                                                            label
                                                        } </button>
                                                    );
                                                }

                                                return ( <a key = {
                                                        `${project.id}-${label}-${href}`
                                                    }
                                                    className = "project-card__link"
                                                    href = {
                                                        href
                                                    }
                                                    target = "_blank"
                                                    rel = "noreferrer" >
                                                    {
                                                        label
                                                    } </a>
                                                );
                                            })
                                        } </div>
                                    ) : null
                                } </article>
                            ))
                    }

                    {
                        !visibleProjects.length ? ( <div className = "projects-emptyState" >
                            <div className = "projects-emptyState__title" > No projects in this category. </div> <p className = "projects-emptyState__text" > Change the active category to bring project cards back into view. </p> </div>
                        ) : null
                    } </div> </section> </div>

                    <div className = "projects-fixedBack" >
                    <button type = "button"
                    className = "projects-action projects-action--primary"
                    onClick = {
                        () => navigate('/main')
                    } >
                    Back to Main Menu </button> </div> </div>
                );
            }
